// §C (Addendum June 2026): GA-triggered education checklist config
// Reads boundaries from settings/educationChecklistConfig, falling back to DEFAULT_EDUCATION_CHECKLIST_CONFIG.
// Any admin update in Firestore takes effect immediately — no code deploy needed.

import {
  DEFAULT_EDUCATION_CHECKLIST_CONFIG,
  EDUCATION_CHECKLIST_CONFIG_DOC,
  EducationChecklistConfig,
  SETTINGS,
} from '@hb/shared'
import { useMemo } from 'react'
import { useDocument } from '../../../backend/db/hooks'

export const useEducationConfig = (): EducationChecklistConfig => {
  const { data } = useDocument<EducationChecklistConfig>(SETTINGS, EDUCATION_CHECKLIST_CONFIG_DOC)

  return useMemo<EducationChecklistConfig>(
    () => ({ ...DEFAULT_EDUCATION_CHECKLIST_CONFIG, ...data }),
    [data],
  )
}
